import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { RepositoryService } from '../smoothr-web-app-core/services/repository/repository.service';
import { SharedModuleModule } from './shared-module/shared-module.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientModule, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ModalInfoComponent } from './components/modal-info/modal-info.component';
import { CheckoutModalComponent } from './components/checkout-modal/checkout-modal.component';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HomePageModule } from './pages/home/home.module';
import { MenuPageModule } from './pages/menu/menu.module';
import { SuccessPageModule } from './pages/payment-success/payment-success.module';
import { OrderPageModule } from './pages/order/order.module';
import { SignUpPageModule } from './pages/sign-up/sign-up.module';
import { MyOrdersPageModule } from './pages/my-orders/my-orders.module';
import { SignInPageModule } from './pages/sign-in/sign-in.module';
import { EmailConfirmationPageModule } from './pages/email-confirmation/email-confirmation.module';
import { AccountPageModule } from './pages/account/account.module';
import { ModalNavigationGuard } from './modal-navigation-guard';
import { RecommendationModalComponent } from './components/recommendation-modal/recommendation-modal.component';
import { PaymentModalComponent } from '../smoothr-web-app-core/components/payment-modal/payment-modal.component';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { AnalyticsService } from '../smoothr-web-app-core/services/analytics/analytics.service';
import { CookieService } from 'ngx-cookie-service';
import { CheckOrderGuard } from './guard/check-order-guard';
import { createTranslateLoader } from './translate-loader';
import { ReactiveFormsModule } from '@angular/forms';
import { NeptingPaymentPageModule } from './pages/nepting-payment/nepting-payment.module';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

const config: SocketIoConfig = {
	url: environment.baseUrl,
	options: {
		path: '/v1/socketio/socket.io/',
	},
};

@NgModule({
	declarations: [
		AppComponent,
		ModalInfoComponent,
		CheckoutModalComponent,
		RecommendationModalComponent,
		PaymentModalComponent,
	],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		IonicModule.forRoot({
			spinner: 'crescent',
			swipeBackEnabled: false,
			scrollAssist: false,
			mode: 'md',
		}),
		AppRoutingModule,
		SharedModuleModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		HttpClientModule,
		NoopAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		HomePageModule,
		EmailConfirmationPageModule,
		MenuPageModule,
		SuccessPageModule,
		OrderPageModule,
		AccountPageModule,
		NeptingPaymentPageModule,
		SignUpPageModule,
		MyOrdersPageModule,
		SignInPageModule,
		TranslateModule.forRoot({
			defaultLanguage: 'en',
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient],
			},
		}),
		SocketIoModule.forRoot(config),
	],
	providers: [
		CookieService,
		AnalyticsService,
		RepositoryService,
		ModalNavigationGuard,
		CheckOrderGuard,
		{ provide: LOCALE_ID, useValue: 'en-EN' },
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
		provideHttpClient(withInterceptorsFromDi()),
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
